const returnColorByString = (string, option)=>{
    if(option === "light") {
        if(string === "레어"){
            return "#40B2FF"
        } else if ( string === "에픽") {
            return "#B340FF"
        } else if ( string === "유니크") {
            return "#FFD540"
        } else if ( string === "레전드리") {
            return "#40FF73"
        } else {
            return "#ffffff"
        }
    } else {
        if(string === "레어"){
            return "#0084E8"
        } else if ( string === "에픽") {
            return "#AF5CA2"
        } else if ( string === "유니크") {
            return "#CCB35C"
        } else if ( string === "레전드리") {
            return "#5CCC7A"
        } else {
            return "#999999"
        }
    }

}


export default returnColorByString;